import 'utils/polyfills';
import 'utils/rollbar';
import React from 'react';
import ReactDOM from 'react-dom';

import { checksAllLinksAreSafe } from 'typescripts/services/utils/security.service';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import { dropdown } from 'components/shared/dropdown';
import { personalizedTheme } from 'typescripts/theme';
import CordovaCtrl from 'controllers/shared/cordova.ctrl';
import autoloadComponents from 'typescripts/components/auto-load';
import RollbarComponent from 'typescripts/components/shared/rollbar.component';
import CastingContainerDesktopComponent from 'typescripts/components/suppliers/castings/casting-container-desktop.component';

document.addEventListener('DOMContentLoaded', () => {
  autoloadComponents();
  checksAllLinksAreSafe();

  const castingContainer = document.getElementById('js-casting-container');
  if (!castingContainer) return;

  ReactDOM.render(
    <RollbarComponent>
      <ThemeProvider theme={{ ...personalizedTheme(window.marketColors), roundCornerInsideTooltips: true }}>
        <StyleSheetManager>
          <CastingContainerDesktopComponent { ...window.dataForCastingForm } />
        </StyleSheetManager>
      </ThemeProvider>
    </RollbarComponent>
  , castingContainer);

  CordovaCtrl();
});

dropdown('.dropdown-link');

// do not open a file dropped (ex. dropped outside a upload zone)
window.addEventListener('dragover', e => e.preventDefault(), false);
window.addEventListener('drop', e => e.preventDefault(), false);
